/**
 * Komal OS - NCR Store
 * Manages the NCR list, detail, and create/close actions.
 */

import { create } from 'zustand';
import * as ncrService from '../services/ncrService';

const useNcrStore = create((set, get) => ({
  ncrReports: [],
  selectedNcr: null,
  isLoading: false,
  isSubmitting: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchNCRs: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const response = await ncrService.getNCRs(params);
      set({ ncrReports: response.data.ncr_reports || [], isLoading: false });
      return response.data.ncr_reports;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load NCRs';
      set({ error: message, isLoading: false });
      return [];
    }
  },

  fetchNCR: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await ncrService.getNCR(id);
      set({ selectedNcr: response.data.ncr, isLoading: false });
      return response.data.ncr;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load NCR';
      set({ error: message, isLoading: false });
      return null;
    }
  },

  createNCR: async (data) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await ncrService.createNCR(data);
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to create NCR';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },

  closeNCR: async (id, data) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await ncrService.closeNCR(id, data);
      await get().fetchNCR(id);
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to close NCR';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },
}));

export default useNcrStore;
